import { BASE_PATH } from "../utils/constants";

export async function getLanguages(language) {
    try {
        const url = `${BASE_PATH}/speaking-languages`;
        const response = await fetch(url);
        const result = await response.json();
        console.log(result);
        if (language == "en") {
            const filteredResult = result.filter(item => item.languageValue === "en");
            //console.log("en = ", filteredResult)

            return filteredResult;

        }
        else {
            const filteredResult = result.filter(item => item.languageValue === "es");
            //console.log("es = ", filteredResult)
            return filteredResult;


        }
    } catch (error) {
        console.log(error);
        return null;
    }
}